import {clsx} from 'clsx'
import styles from './ActionItems.module.css'

export function ActionItemsList({children, className}: {children: React.ReactNode; className?: string}) {
  return (
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    <ul role="list" className={clsx(styles.actionItemList, className)}>
      {children}
    </ul>
  )
}
